import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { preparePendoCustomListEvent } from '@modules/pendo'
import { usePendoTrackEvent } from '@modules/pendo/hooks/usePendoTrackEvent'
import { PendoEventType } from '@modules/pendo/types'
import ClearIcon from '@mui/icons-material/Clear'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'

import CustomSearchIcon from './CustomSearchIcon'
import { SearchFieldProps } from './types'

export const SearchField = ({ searchQuery, onSearchChange, disabled }: SearchFieldProps) => {
  const { t } = useTranslation()
  const { user } = useAuthContext()

  const { trackPendoEvent } = usePendoTrackEvent()

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value)

    trackPendoEvent(
      PendoEventType.ShortlistProfilesSearch,
      preparePendoCustomListEvent({
        eventType: 'Type in the keyword search box',
        user,
      }),
    )
  }

  const handleClearSearch = () => {
    trackPendoEvent(
      PendoEventType.ShortlistProfilesSearch,
      preparePendoCustomListEvent({
        eventType: 'Click on the x in the keyword search box',
        user,
      }),
    )
    onSearchChange('')
  }

  return (
    <Box sx={{ marginLeft: 'auto', width: '300px', ml: 2 }} id="shortlist-search_title">
      <TextField
        value={searchQuery}
        onChange={handleSearchChange}
        variant="outlined"
        disabled={disabled}
        size="small"
        fullWidth
        label={t(translationKeys.CUSTOM_LIST_SEARCH_PLACEHOLDER)}
        InputLabelProps={{
          sx: {
            color: '#0B7CB7',
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CustomSearchIcon style={{ color: disabled ? 'inherit' : '#0B7CB7' }} />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClearSearch}
                sx={{
                  padding: '4px',
                }}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#0B7CB7',
            },
          },
        }}
      />
    </Box>
  )
}
